import { render, staticRenderFns } from "./CustomerSuccessAddCompanyModal.vue?vue&type=template&id=7bc467f3&"
import script from "./CustomerSuccessAddCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerSuccessAddCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports